module.exports = __webpack_public_path__ + "static/media/wecycle-bin.3865d274.png";